// extracted by mini-css-extract-plugin
module.exports = {"cardsRow":"styles_cardsRow__n2awD","infoCardWrapper":"styles_infoCardWrapper__AoQEK"};